export default __webpack_public_path__ + "static/media/LF-1Open.5950c909.png";